import { r as registerInstance, c as getElement, h } from './index-34617187.js';
import { a as BxfProgressIndicatorTypeEnum, B as BxfProgressIndicatorSizeEnum } from './bxf-progress-indicator-type.enum-57cadbc2.js';
import { B as BxfProgressIndicatorConstants } from './bxf-progress-indicator.constants-a18a55b5.js';
import { i as isUsingI18n, B as BxfI18n, t as translateKeys } from './i18n.config-355137b0.js';
import { l as createSelector } from './bxf-utils-3908c3c5.js';
import 'lodash-es';
import 'dompurify';

const bxfProgressIndicatorCss = "button.sc-bxf-progress-indicator:hover,a.sc-bxf-progress-indicator:hover,input[type=radio].sc-bxf-progress-indicator:hover,input[type=checkbox].sc-bxf-progress-indicator:hover,input[type=radio].sc-bxf-progress-indicator:checked:hover,input[type=checkbox].sc-bxf-progress-indicator:checked:hover,svg.sc-bxf-progress-indicator:hover{cursor:pointer}svg[disabled].sc-bxf-progress-indicator:hover,button[disabled].sc-bxf-progress-indicator:hover,label[disabled].sc-bxf-progress-indicator:hover,input[type=checkbox].sc-bxf-progress-indicator:disabled:hover,input[type=radio].sc-bxf-progress-indicator:disabled:hover,input[type=checkbox].sc-bxf-progress-indicator:checked:disabled:hover,input[type=radio].sc-bxf-progress-indicator:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-progress-indicator{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-progress-indicator-bar__wrapper.sc-bxf-progress-indicator{display:flex;flex-direction:row;align-items:center}.bxf-progress-indicator-bar__wrapper.sc-bxf-progress-indicator>div.sc-bxf-progress-indicator:not(:first-child){margin-left:0.5rem}.bxf-progress-indicator-bar__regular.sc-bxf-progress-indicator{height:0.25rem;width:100%;background-color:#d9d6ce;margin-bottom:0.25rem}.bxf-progress-indicator-bar__regular--right-label.sc-bxf-progress-indicator{height:0.25rem;width:100%;background-color:#d9d6ce}.bxf-progress-indicator-bar__regular--progress.sc-bxf-progress-indicator{height:inherit;background-color:#000000}.bxf-progress-indicator-bar__large.sc-bxf-progress-indicator{height:0.5rem;width:100%;background-color:#d9d6ce}.bxf-progress-indicator-bar__large--progress.sc-bxf-progress-indicator{height:inherit;background-color:#000000}.bxf-progress-indicator__counter.sc-bxf-progress-indicator{color:#000000;font-size:0.75rem;line-height:1.3333333333}.bxf-progress-indicator__label.sc-bxf-progress-indicator{color:#000000;font-size:0.8125rem;line-height:1.2307692308;flex:1;width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;text-align:left;margin-right:0.75rem}.bxf-progress-indicator__label-counter--container.sc-bxf-progress-indicator{display:flex;justify-content:space-between;width:100%;padding-bottom:0.5rem}.bxf-progress-ring__container.sc-bxf-progress-indicator{display:flex;flex-direction:column;align-items:center;color:#000000}.bxf-progress-ring__container.sc-bxf-progress-indicator svg.sc-bxf-progress-indicator{forced-color-adjust:auto}.bxf-progress-ring__container.sc-bxf-progress-indicator svg.sc-bxf-progress-indicator:hover{cursor:default}.bxf-progress-ring.sc-bxf-progress-indicator{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite}.bxf-progress-ring__overlay.sc-bxf-progress-indicator{display:flex;justify-content:center;align-items:center;position:absolute;top:0;left:0;width:100%;height:100%;background-color:#d9d6ce}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg)}}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.bxf-progress-ring__circle.sc-bxf-progress-indicator,.bxf-progress-ring__background-circle.sc-bxf-progress-indicator{stroke-width:4;stroke:currentColor;fill:none}.bxf-progress-ring__circle.sc-bxf-progress-indicator{transition:stroke-dashoffset 0.35s;transform:rotate(-90deg);transform-origin:50% 50%}.bxf-progress-ring__background-circle.sc-bxf-progress-indicator{color:#d9d6ce;forced-color-adjust:auto;display:flex;flex-direction:column;align-items:center}.bxf-progress-ring-label__regular.sc-bxf-progress-indicator{padding-top:0.75rem;color:#000000;font-size:0.8125rem;line-height:1.2307692308}.bxf-progress-ring-label__large.sc-bxf-progress-indicator{padding-top:1.25rem;color:#000000;font-size:0.8125rem;line-height:1.5384615385}@media (forced-colors: active){.bxf-progress-ring__container.sc-bxf-progress-indicator{color:Highlight}.bxf-progress-indicator-bar__regular--progress.sc-bxf-progress-indicator,.bxf-progress-indicator-bar__large--progress.sc-bxf-progress-indicator{background-color:Highlight}.bxf-progress-ring__container.sc-bxf-progress-indicator svg.sc-bxf-progress-indicator,.bxf-progress-ring__background-circle.sc-bxf-progress-indicator,.bxf-progress-indicator-bar__regular.sc-bxf-progress-indicator,.bxf-progress-indicator-bar__regular--right-label.sc-bxf-progress-indicator,.bxf-progress-indicator-bar__large.sc-bxf-progress-indicator{outline:0.0625rem solid ButtonBorder}.bxf-progress-ring__background-circle.sc-bxf-progress-indicator{color:Canvas;outline-offset:-0.3125rem}}";
const BxfProgressIndicatorStyle0 = bxfProgressIndicatorCss;

const BxfProgressIndicator = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
        this.type = BxfProgressIndicatorTypeEnum.BAR;
        this.size = BxfProgressIndicatorSizeEnum.LARGE;
        this.progress = 0;
        this.loadingLabel = 'Loading';
        this.hasLabel = false;
        this.hasCounter = false;
        this.isSpinner = true;
        this.isOverlay = false;
        this.isTracking = true;
        this.trackingData = undefined;
        this.dataTestSuffix = undefined;
    }
    _constants = BxfProgressIndicatorConstants;
    _progressRef;
    _circleRef;
    _circleBackgroundRef;
    _svgRef;
    get host() { return getElement(this); }
    progressDidChange() {
        /* istanbul ignore else */
        if (this._progressRef) {
            this._progressRef.style.width = this.progress + '%';
        }
        /* istanbul ignore else */
        if (this.type === BxfProgressIndicatorTypeEnum.LOADING) {
            this.setLoadingStyle();
            this.setProgress(this.progress);
        }
    }
    componentWillLoad() {
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        this.verifyProgress();
        /* istanbul ignore else */
        if (this.isSpinner) {
            this.progress = this._constants.STRING.BXF_PROGRESS_SPINNER_VALUE;
            this.hasCounter = false;
        }
    }
    componentWillUpdate() {
        this.verifyProgress();
    }
    componentDidLoad() {
        this.progressDidChange();
    }
    disconnectedCallback() {
        this.i18n?.destroyTranslations();
    }
    i18n;
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
    }
    /**
     * Private method to set progress in edge cases
     */
    verifyProgress() {
        /* istanbul ignore else */
        if (this.progress > 100) {
            this.progress = 100;
        }
        /* istanbul ignore else */
        if (this.progress < 0) {
            this.progress = 0;
        }
    }
    /**
     * Private method to set loading indicator styling
     */
    setLoadingStyle() {
        if (this.size === BxfProgressIndicatorSizeEnum.LARGE) {
            /* istanbul ignore else */
            if (this._svgRef) {
                this.setElementDimension(this._svgRef, 5);
            }
            /* istanbul ignore else */
            if (this._circleBackgroundRef) {
                this.setSVGDimension(this._circleBackgroundRef, 38, 40);
            }
            /* istanbul ignore else */
            if (this._circleRef) {
                this.setSVGDimension(this._circleRef, 38, 40);
            }
        }
        else {
            /* istanbul ignore else */
            if (this._svgRef) {
                this.setElementDimension(this._svgRef, 2);
            }
            /* istanbul ignore else */
            if (this._circleBackgroundRef) {
                this.setSVGDimension(this._circleBackgroundRef, 14, 16);
            }
            /* istanbul ignore else */
            if (this._circleRef) {
                this.setSVGDimension(this._circleRef, 14, 16);
            }
        }
    }
    /**
     * Private method to set dimension of svg element
     */
    setElementDimension(element, dimension) {
        element.style.height = dimension + 'rem';
        element.style.width = dimension + 'rem';
        element.style['border-radius'] = dimension / 2 + 'rem';
        element.setAttribute('viewBox', `0 0 ${dimension * 16} ${dimension * 16}`);
    }
    /**
     * Private method to set dimension of circle inside svg element
     */
    setSVGDimension(element, radius, center) {
        element.r.baseVal.value = radius;
        element.cx.baseVal.value = center;
        element.cy.baseVal.value = center;
        // add border-radius for outlines
        element.style['border-radius'] = `${radius / 16}rem}`;
    }
    /**
     * Private method to css class to bar progress indicator
     */
    get barContainerCss() {
        return `${this.size === BxfProgressIndicatorSizeEnum.LARGE
            ? this._constants.STRING.BXF_PROGRESS_INDICATOR_BAR_LARGE
            : this.regularBarContainerCss}`;
    }
    get regularBarContainerCss() {
        return `${!this.hasLabel && this.hasCounter
            ? this._constants.STRING
                .BXF_PROGRESS_INDICATOR_BAR_REGULAR_RIGHT_LABEL
            : this._constants.STRING.BXF_PROGRESS_INDICATOR_BAR_REGULAR}`;
    }
    /**
     * Private method to css class to progress in bar progress indicator
     */
    get barProgressCss() {
        return `${this.size === BxfProgressIndicatorSizeEnum.LARGE
            ? this._constants.STRING
                .BXF_PROGRESS_INDICATOR_BAR_LARGE_PROGRESS
            : this._constants.STRING
                .BXF_PROGRESS_INDICATOR_BAR_REGULAR_PROGRESS}`;
    }
    /**
     * Private method to set progress in loading indicator
     */
    setProgress(value) {
        /* istanbul ignore else */
        if (this._circleRef) {
            const radius = this._circleRef.r.baseVal.value;
            const circumference = radius * 2 * Math.PI;
            this._circleRef.style.strokeDasharray = `${circumference} ${circumference}`;
            const offset = circumference - (value / 100) * circumference;
            this._circleRef.style.strokeDashoffset = `${offset}`;
        }
    }
    /**
     * Private method to set css class to loading labels
     */
    get loadingLabelCss() {
        return this.size === BxfProgressIndicatorSizeEnum.REGULAR
            ? this._constants.STRING.BXF_PROGRESS_RING_LABEL_REGULAR
            : this._constants.STRING.BXF_PROGRESS_RING_LABEL_LARGE;
    }
    /**
     * Private method to decide string to show as label
     */
    get loadingLabelString() {
        /* istanbul ignore else */
        if (this.hasLabel) {
            return this.loadingLabel;
        }
        /* istanbul ignore else */
        if (this.hasCounter) {
            return this.progress + '%';
        }
    }
    renderRightCounter() {
        /* istanbul ignore else */
        if (!this.hasLabel && this.hasCounter) {
            return this.renderCounter();
        }
    }
    renderCounter() {
        /* istanbul ignore else */
        if (this.hasCounter) {
            return (h("div", { class: this._constants.STRING.BXF_PROGRESS_INDICATOR_COUNTER, "aria-hidden": 'true' }, this.progress, "%"));
        }
    }
    renderLabel() {
        /* istanbul ignore else */
        if (this.hasLabel) {
            return (h("div", { class: this._constants.STRING.BXF_PROGRESS_INDICATOR_LABEL, "aria-hidden": 'true' }, this.loadingLabel));
        }
    }
    renderLabelWithCounter() {
        /* istanbul ignore else */
        if (this.hasLabel) {
            return (h("div", { class: this._constants.STRING
                    .BXF_PROGRESS_INDICATOR_LABEL_COUNTER_CONTAINER }, this.renderLabel(), this.renderCounter()));
        }
    }
    renderBars() {
        return (h("div", { class: this.barContainerCss, role: 'progressbar', "aria-valuemin": '0', "aria-valuemax": '100', "aria-valuenow": `${this.progress}`, "aria-label": this.loadingLabel }, h("div", { ref: (el) => (this._progressRef = el), class: this.barProgressCss })));
    }
    renderProgressBar() {
        return (h("div", { class: this._constants.STRING.BXF_PROGRESS_INDICATOR_BAR_WRAPPER }, this.renderBars(), this.renderRightCounter()));
    }
    renderCircleRingBackground() {
        return (h("circle", { ref: (el) => (this._circleBackgroundRef = el), class: this._constants.STRING.BXF_PROGRESS_RING_CIRCLE_BACKGROUND }));
    }
    renderCircleRingProgress() {
        return (h("circle", { ref: (el) => (this._circleRef = el), class: this._constants.STRING.BXF_PROGRESS_RING_CIRCLE }));
    }
    renderLoadingProgress() {
        const { BXF_PROGRESS_RING_CONTAINER, BXF_PROGRESS_RING, BXF_PROGRESS_RING_OVERLAY, } = this._constants.STRING;
        return (h("div", { class: `${BXF_PROGRESS_RING_CONTAINER} ${this.isOverlay ? BXF_PROGRESS_RING_OVERLAY : ''}`, role: 'progressbar', "aria-valuemin": this.isSpinner ? null : '0', "aria-valuemax": this.isSpinner ? null : '100', "aria-valuenow": this.isSpinner ? null : `${this.progress}`, "aria-label": this.loadingLabel }, h("svg", { class: this.isSpinner ? BXF_PROGRESS_RING : '', ref: (el) => (this._svgRef = el), "aria-hidden": 'true' }, this.renderCircleRingBackground(), this.renderCircleRingProgress()), this.renderLoadingLabel()));
    }
    renderLoadingLabel() {
        /* istanbul ignore else */
        if (this.hasLabel || this.hasCounter) {
            return (h("div", { class: this.loadingLabelCss, "aria-hidden": 'true' }, this.loadingLabelString));
        }
        return null;
    }
    render() {
        if (this.type === BxfProgressIndicatorTypeEnum.BAR) {
            return (h("span", { "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, this.renderLabelWithCounter(), this.renderProgressBar()));
        }
        else {
            return (h("span", { "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, this.renderLoadingProgress()));
        }
    }
    static get watchers() { return {
        "progress": ["progressDidChange"]
    }; }
};
BxfProgressIndicator.style = BxfProgressIndicatorStyle0;

export { BxfProgressIndicator as bxf_progress_indicator };
